export interface ServicePackage {
  id: string;
  name: string;
  price: string;
  duration: string;
  tagline: string;
  description: string;
  featured: boolean;
  badge?: string;
}

export const servicePackages: ServicePackage[] = [
  {
    id: 'starter',
    name: 'Smile Starter',
    price: '99€',
    duration: '30 Min.',
    tagline: 'Perfekt für den Einstieg',
    description: 'Dein erster Schritt zu einem strahlenden Lächeln. Ideal für eine schnelle Auffrischung vor einem besonderen Anlass.',
    featured: false,
    badge: 'EINSTIEG',
  },
  {
    id: 'classic',
    name: 'Smile Classic',
    price: '149€',
    duration: '45 Min.',
    tagline: 'Unser Bestseller',
    description: 'Die beliebteste Anwendung für sichtbar hellere Zähne. Mit intensiverer LED-Bestrahlung und tiefenwirksamem PAP-Gel.',
    featured: true,
    badge: 'Beliebteste Wahl',
  },
  {
    id: 'premium',
    name: 'Smile Premium',
    price: '199€',
    duration: '60 Min.',
    tagline: 'Das Beste für dein Lächeln',
    description: 'Maximale Aufhellung in einer Sitzung. Mit erweiterter Anwendung, Zahnpflege-Set und persönlicher Nachsorgeberatung.',
    featured: false,
    badge: 'PREMIUM',
  },
];
